import { FileText } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

export const ServiceDescription = ({ q, update }) => (
  <section className="bg-slate-900 border border-slate-800 rounded-lg p-5" data-testid="service-description-panel">
    <div className="flex items-center gap-2 mb-1">
      <FileText className="h-4 w-4 text-amber-400" />
      <h2 className="font-semibold">Descrizione servizio</h2>
    </div>
    <p className="text-xs text-slate-400 mb-3">Incolla qui il testo: nel PDF diventa la seconda pagina, subito dopo la copertina. Se lo lasci vuoto la pagina non compare.</p>
    <Textarea rows={8} value={q.service_description || ""} onChange={(e) => update({ service_description: e.target.value })}
      placeholder="Testo della descrizione del servizio..." data-testid="service-description-input" />
  </section>
);
